import DonatedSoFar from "./DonatedSoFar";
import { useI18n } from '../../hooks/i18n-hooks';
import clsx from 'clsx';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useLanguage } from "@hilma/netina2all";

interface SoldAndDonatedTextProps {
	kitsSold: number;
	entity: string;
	goalKitsNumber: string;
	donatedSoFar?: string;
	bottom?: boolean;
	dontShowDonated?: boolean;
}

const SoldAndDondatedText: React.FC<SoldAndDonatedTextProps> = ({ kitsSold, entity, goalKitsNumber, donatedSoFar, bottom = false, dontShowDonated }) => {

	const b = useI18n(i => i.am.banner);
	const isMobile = useMediaQuery('(max-width: 800px)');
	const language = useLanguage();
	const assoEntity = useI18n(i => i.am.pending.entityName);

	const theEntitySold = language === 'he' ? `${b.sold}${entity}` : `${b.sold} ${entity.toLowerCase()}`

	return <div className={clsx(bottom && 'bottom-text')}>
		<div className='kits-sold'><span className='num-kits'>{kitsSold}</span>{theEntitySold} {b.this}</div>

		<div className='out-of-donated'>
			<div>{b.outOf} {goalKitsNumber} {b.kits}</div>
			{!bottom && donatedSoFar && !dontShowDonated && !isMobile &&
				<DonatedSoFar donatedSoFar={donatedSoFar} isAsso={entity === assoEntity} />}
		</div>
	</div>
}

export default SoldAndDondatedText;